import React, {useRef} from 'react';
import News from './News';
import {RedirectWithParams} from 'epic-diesel-common';
import {LoadIndicator} from '../../components';
import {useSelector} from 'react-redux';
import {NewsState} from '../../reducers/news.reducer';
import {withPageLayout, WithPageLayoutProps} from '../../hocs';
import {RootState} from '../..';
import {selectNews} from '../../selectors';

export type NewsViewProps = WithPageLayoutProps;

const NewsView: React.FC<NewsViewProps> = props => {
    const newsRef = useRef();
    const newsState = useSelector<RootState, NewsState>(selectNews);
    const {enableNews} = props.configState || {};
    const {loading, lastFetch} = newsState;
    const isInitialLoad = loading && !lastFetch;

    if (!enableNews) {
        return <RedirectWithParams to="overview" />;
    }

    return (
        <LoadIndicator isLoading={isInitialLoad} messages={props.messages}>
            <News newsState={newsState} {...props} ref={newsRef} />
        </LoadIndicator>
    );
};

export default withPageLayout(NewsView);
